"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = OutlinedField;
var _react = _interopRequireWildcard(require("react"));
var _server = require("react-dom/server");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react2 = _interopRequireDefault(require("cleave.js/react"));
require("cleave.js/dist/addons/cleave-phone.us");
var _reactSelect = _interopRequireDefault(require("react-select"));
var _twMerge = require("tw-merge");
var _form = _interopRequireDefault(require("../icons/form"));
var _generic = _interopRequireDefault(require("../icons/generic"));
var _unselectedRadio = _interopRequireDefault(require("../../images/icons/form/unselected-radio.svg"));
var _selectedRadio = _interopRequireDefault(require("../../images/icons/form/selected-radio.svg"));
var _utils = require("../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Components

// Images

// Utils

// Styles
const {
  below,
  canHover
} = (0, _utils.getMediaQueries)();
const MessageContainer = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__MessageContainer",
  componentId: "sc-13zdp9-0"
})(["display:flex;justify-content:flex-end;.character-limit{color:var(--dusky-grey-6-hex);font-size:12px;line-height:16px;justify-self:end;}"]);
const FieldGroup = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__FieldGroup",
  componentId: "sc-13zdp9-1"
})(["margin-bottom:40px;position:relative;&.errors{input,textarea,select,.select__control{border-color:var(--sunset-orange-6-hex) !important;}.character-limit{color:var(--sunset-orange-6-hex);}", "{justify-content:space-between;}}&.icon{input{padding-left:", ";& + label{left:", ";}}}*{font-size:16px;line-height:20px;outline:none;transition:all 0.2s ease-in-out;&:not(.errors):not([disabled]):not(button):focus{border:1px solid var(--pacific-blue-hex);}}label{pointer-events:none;z-index:", ";}"], MessageContainer, props => props.iconPlacement === "left" ? `calc(12px + 20px + 8px)` : "12px", props => props.iconPlacement === "left" ? "calc(12px + 20px + 8px)" : "12px", props => !props.showLabel && -1);
const IconContainer = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__IconContainer",
  componentId: "sc-13zdp9-2"
})(["background:transparent;border:none;display:flex;left:", ";right:", ";position:absolute;top:50%;transform:translateY(-50%);z-index:1;&:hover ~ input{:not([disabled]):not(:focus){border-color:var(--orca-grey-8-hex);}}", ""], props => props.iconPlacement === "left" && "12px", props => props.iconPlacement === "right" && "12px", canHover`
    :hover ~ input {
      :not([disabled]):hover {
        border-color: var(--orca-grey-8-hex);
      }
    }
  `);
const RelativePositionContainer = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__RelativePositionContainer",
  componentId: "sc-13zdp9-3"
})(["position:relative;"]);
const InputGroup = (0, _styledComponents.default)(FieldGroup).withConfig({
  displayName: "outlined-field__InputGroup",
  componentId: "sc-13zdp9-4"
})(["position:relative;width:100%;input{border-radius:4px;border:1px solid var(--grey-4-hex);box-sizing:border-box;display:block;height:64px;padding:0px 12px;width:100%;&:not([value=\"\"]){padding-top:", ";& + label{opacity:", ";}}&[value=\"\"]{& + label{opacity:0;}}&::placeholder{color:var(--dusky-grey-6-hex);transition-delay:0.1s;}&[disabled]{background:#fff;border-color:var(--grey-3-hex);color:var(--orca-grey-8-hex);&::placeholder{color:var(--grey-3-hex);}& ~ label{color:var(--grey-3-hex);}}&:focus{color:var(--orca-grey-8-hex);padding-top:", ";&::placeholder{opacity:0;transition-delay:0s;}& ~ label{opacity:1;transition-delay:0.1s;}}", "}label{position:absolute;top:12px;left:12px;font-size:14px;line-height:16px;color:var(--dusky-grey-6-hex);}"], props => props.showLabel && "12px", props => !props.showLabel ? 0 : 1, props => props.showLabel && "12px", canHover`
      :not([disabled]):hover {
        border-color: var(--orca-grey-8-hex);
      }
    `);
const Rosie = _styledComponents.default.input.withConfig({
  displayName: "outlined-field__Rosie",
  componentId: "sc-13zdp9-5"
})(["opacity:0;position:absolute;top:0;left:0;height:0;width:0;z-index:-1;"]);
const SelectGroup = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__SelectGroup",
  componentId: "sc-13zdp9-6"
})(["position:relative;width:100%;label{color:var(--dusky-grey-6-hex);font-size:14px;left:12px;line-height:16px;opacity:0;position:absolute;top:12px;transition-delay:0s;}.select__indicators{position:absolute;right:12px;top:50%;transform:translateY(-50%);}.select__indicator-separator{display:none;}.select__placeholder{display:flex;}.select__option{color:var(--orca-grey-8-hex);cursor:pointer;font-size:16px;line-height:20px;&--is-focused{background:var(--arctic-blue-1-hex);}&--is-selected{background:var(--arctic-blue-2-hex);}", "}.select__value-container{justify-items:start;padding:0;*{margin:0;}}select,.select__control{background-color:#fff;border:0.5px solid ", ";border-radius:4px;box-shadow:none;box-sizing:border-box;color:var(--dusky-grey-6-hex);cursor:pointer;font-size:16px;height:64px;line-height:20px;margin:0;padding:0 12px;outline:none;width:100%;&[disabled],&--is-disabled{border-color:var(--grey-3-hex);}", "}.select{&:focus-within{color:var(--orca-grey-8-hex);.select__control{padding-top:", ";}& ~ label{opacity:", ";}input::placeholder{transition-delay:0s;}& ~ label{transition-delay:100ms;}}}"], canHover`
      &:not(&--is-selected):hover {
        background: var(--arctic-blue-1-hex);
      }
    `, props => props.isSelectFocused ? "var(--pacific-blue-hex)" : "var(--grey-4-hex)", canHover`
      :not([disabled]):hover {
        border-color: ${props => !props.isSelectFocused ? "var(--orca-grey-8-hex)" : "var(--pacific-blue-hex)"};
      }
    `, props => props.showLabel && "12px", props => !props.showLabel ? 0 : 1);
const TextAreaGroup = (0, _styledComponents.default)(FieldGroup).withConfig({
  displayName: "outlined-field__TextAreaGroup",
  componentId: "sc-13zdp9-7"
})(["position:relative;width:100%;label{color:var(--dusky-grey-6-hex);font-size:14px;line-height:16px;position:absolute;top:12px;left:12px;opacity:", ";}textarea{border:1px solid var(--grey-4-hex);border-radius:4px;box-sizing:border-box;color:var(--orca-grey-8-hex);font-size:16px;height:96px;line-height:20px;padding:8px 12px;padding-top:", ";resize:none;width:100%;&::placeholder{color:var(--dusky-grey-6-hex);font-size:16px;line-height:20px;opacity:1;}:focus{color:var(--orca-grey-8-hex);padding-top:", ";&::placeholder{opacity:0;transition-delay:0s;}& ~ label{opacity:1;transition-delay:0.1s;}}:not([disabled]):hover{border-color:var(--orca-grey-8-hex);}&[disabled]{background:#fff;border-color:var(--grey-3-hex);::placeholder{color:var(--grey-3-hex);}}}"], props => props.isFieldEmpty || !props.showLabel ? 0 : 1, props => !props.isFieldEmpty && props.showLabel && "calc(12px + 16px)", props => props.showLabel && "calc(12px + 16px)");
const RadioGroup = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__RadioGroup",
  componentId: "sc-13zdp9-8"
})(["padding-block:12px;&.errors input:not([disabled]) + label::before{background-image:url(data:image/svg+xml,", ");}"], encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "unselected-radio",
  borderColor: _utils.colors["sunset-orange-6"].hex
}))));
const RadioLabel = _styledComponents.default.label.withConfig({
  displayName: "outlined-field__RadioLabel",
  componentId: "sc-13zdp9-9"
})(["--line-height:20px;display:inline-block;font-size:16px;line-height:var(--line-height);padding-inline-start:calc(16px + 8px);opacity:1 !important;pointer-events:initial !important;position:relative !important;text-transform:initial !important;&::before{content:\"\";display:inline-block;height:16px;left:0px;position:absolute;top:calc(var(--line-height) / 2);transform:translateY(-50%);width:16px;}", " &:last-child{}&.errors{border-color:var(--sunset-orange-6-hex) !important;}"], below.mobile`
  //  margin: 16px 24px 0 0;
   `);
const RadioInput = _styledComponents.default.input.withConfig({
  displayName: "outlined-field__RadioInput",
  componentId: "sc-13zdp9-10"
})(["height:0px;position:relative;pointer-events:initial;opacity:0;width:0;&:not([disabled]){& + label::before{background-image:url(", ");background-image:url(data:image/svg+xml,", ");}&:checked + label{border:none;&::before{background-image:url(", ");background-image:url(data:image/svg+xml,", ");}}", "}&[disabled] + label{color:var(--grey-3-hex);&::before{background-image:url(data:image/svg+xml,", ");}}", ""], _unselectedRadio.default, encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "unselected-radio",
  borderColor: _utils.colors["dusky-grey-6"].hex
}))), _selectedRadio.default, encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "selected-radio"
}))), canHover`
      &:hover:not(:checked) + label::before {
        background-image: url(data:image/svg+xml,${encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "unselected-radio",
  borderColor: _utils.colors["orca-grey-8"].hex
})))});
      }
    `, encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "disabled-radio",
  borderColor: _utils.colors["grey-3"].hex
}))), below.mobile`margin-bottom: 0px;`);
const CheckboxGroup = (0, _styledComponents.default)(RadioGroup).withConfig({
  displayName: "outlined-field__CheckboxGroup",
  componentId: "sc-13zdp9-11"
})(["padding:8px 12px;&.errors input:not([disabled]) + label::before{background-image:url(data:image/svg+xml,", ");}label{--line-height:32px;color:var(--dusky-grey-6-hex);font-size:20px;line-height:var(--line-height);}"], encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "unselected-checkbox",
  borderColor: _utils.colors["sunset-orange-6"].hex
}))));
const CheckboxInput = (0, _styledComponents.default)(RadioInput).withConfig({
  displayName: "outlined-field__CheckboxInput",
  componentId: "sc-13zdp9-12"
})(["&:not([disabled]){& + label::before{background-image:url(data:image/svg+xml,", ");}&:checked + label{border:none;color:var(--orca-grey-8-hex);&::before{background-image:url(data:image/svg+xml,", ");}}", "}&[disabled] + label{color:var(--grey-3-hex);&::before{background-image:url(data:image/svg+xml,", ");}}"], encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "unselected-checkbox",
  borderColor: _utils.colors["dusky-grey-6"].hex
}))), encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "selected-checkbox",
  borderColor: _utils.colors["orca-grey-8"].hex
}))), canHover`
      &:hover:not(:checked) + label::before {
        content: "";
        background-image: url(data:image/svg+xml,${encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "unselected-checkbox",
  borderColor: _utils.colors["orca-grey-8"].hex
})))});
      }
      &:hover + label {
        color: var(--orca-grey-8-hex);
      }
    `, encodeURIComponent((0, _server.renderToString)( /*#__PURE__*/_react.default.createElement(_form.default, {
  icon: "disabled-checkbox",
  borderColor: _utils.colors["grey-3"].hex
}))));
const ErrorMessage = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__ErrorMessage",
  componentId: "sc-13zdp9-13"
})(["color:var(--sunset-orange-6-hex);font-size:12px;line-height:16px;margin-top:4px;"]);
const Tooltip = _styledComponents.default.div.withConfig({
  displayName: "outlined-field__Tooltip",
  componentId: "sc-13zdp9-14"
})(["background:var(--ice-grey-1-hex);border:0.5px solid #007ab4;border-radius:2px;box-shadow:0px 1px 16px 2px rgba(117,128,143,0.1);display:flex;flex-direction:column;row-gap:18px;max-width:100%;padding:16px;position:absolute;right:", ";z-index:2;&.icon-tooltip--placement-bottom{bottom:-5px;transform:translateY(100%);}&.icon-tooltip--placement-top{top:-5px;transform:translateY(-100%);}*{color:#007ab4;font-size:14px;line-height:16px;margin:0;}"], props => props.iconPlacement === "right" && 0);

// Main Component
function OutlinedField({
  field,
  errors,
  type,
  name,
  id,
  placeholder,
  defaultValue,
  ref,
  className,
  labelText,
  errorMessage,
  register,
  inputType,
  control,
  Controller,
  rules,
  selectOptions,
  selectFieldClassNames,
  cols,
  rows,
  ariaLabel,
  value,
  iconName,
  iconPlacement,
  iconFunctions,
  iconTooltipText,
  iconTooltipPlacement,
  onChange,
  onBlur,
  iconTitle,
  disabled,
  characterLimit,
  watch,
  isSearchable,
  cleaveOptions,
  showLabel
}) {
  const {
    0: isSelectFocused,
    1: setIsSelectFocused
  } = (0, _react.useState)(null);
  const {
    0: showIconTooltip,
    1: setShowIconTooltip
  } = (0, _react.useState)(false);
  const {
    0: cleave,
    1: setCleave
  } = (0, _react.useState)(null);
  const validateNumber = value => {
    return isNaN((0, _utils.getRawNumber)(value)) ? false : true;
  };
  const outlinedField = type => {
    let formElement;
    let nameAttribute = name || type;
    let idAttribute = id || nameAttribute;
    let typeAttribute = inputType;
    let placeholderAttribute = placeholder;
    let defaultValueAttribute = defaultValue || "";
    let disabledAttribute = disabled;
    let ariaLabelAttribute = ariaLabel || id;
    let allRules = rules;
    let allCleaveOptions = cleaveOptions;
    let labelTxt = labelText || placeholderAttribute;
    let errorMsg = errorMessage || `This doesn't seem quite right.`;
    const numberErrorMsg = errorMessage || "Please enter a number in this field";
    let fieldGroupProps = {
      className: `${className ? className : ""} outlined-field ${iconName ? "icon" : ""} ${errors && errors[nameAttribute] ? "errors" : ""}`
    };
    const getEventHandlers = field => {
      return {
        onChange: e => {
          if (field) field.onChange(e);
          if (onChange) onChange(e, cleave, watch);
        },
        onBlur: e => {
          if (field) field.onBlur(e);
          if (onBlur) onBlur(e, cleave, watch);
        }
      };
    };
    const inputIconFunctions = {
      onClick: () => {
        if (iconFunctions !== null && iconFunctions !== void 0 && iconFunctions.onClick) iconFunctions.onClick();
        if (iconTooltipText) setShowIconTooltip(prevShowIconTooltip => !prevShowIconTooltip);
      }
    };
    const selectIcon = (hasErrors, disabled) => /*#__PURE__*/_react.default.createElement(IconContainer, Object.assign({
      as: iconFunctions ? "button" : "div"
    }, inputIconFunctions, {
      type: iconFunctions && "button",
      className: "icon-container",
      iconPlacement: iconPlacement
    }), /*#__PURE__*/_react.default.createElement(_generic.default, {
      icon: iconName,
      color: hasErrors ? _utils.colors["sunset-orange-6"].hex : disabled ? _utils.colors["grey-3"].hex : _utils.colors["dusky-grey-6"].hex,
      width: 24,
      height: 24,
      title: iconTitle
    }));
    // Text fields
    if (field === "input") {
      fieldGroupProps = {
        ...fieldGroupProps,
        iconPlacement,
        showLabel
      };
      if (type === "email") {
        placeholderAttribute = placeholder || "Email address";
        labelTxt = labelText || placeholderAttribute;
        allRules = {
          required: true,
          pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          ...rules
        };
        errorMsg = errorMessage || `Oh, no! That doesn’t look like an email address. Could you try again?`;
      } else if (type === "name") {
        placeholderAttribute = placeholder || "Your name";
        labelTxt = labelText || placeholderAttribute;
        allRules = {
          required: true,
          minLength: 2,
          ...rules
        };
        errorMsg = errorMessage || `Please enter your full name.`;
      } else if (type === "phone") {
        placeholderAttribute = placeholder || "phone";
        labelTxt = labelText || placeholderAttribute;
        allRules = {
          required: true,
          pattern: /\d{3}-\d{3}-\d{4}$/,
          ...rules
        };
        allCleaveOptions = {
          phone: true,
          phoneRegionCode: "us",
          delimiter: "-",
          ...cleaveOptions
        };
        errorMsg = errorMessage || `Please enter a valid phone number with the area code.`;
      } else if (type === "dollar") {
        allCleaveOptions = {
          numeral: true,
          numeralPositiveOnly: true,
          prefix: "$ ",
          noImmediatePrefix: true,
          rawValueTrimPrefix: true
        };
        allRules = {
          validate: validateNumber,
          ...rules
        };
        errorMsg = numberErrorMsg;
      } else if (type === "percentage") {
        allCleaveOptions = {
          numeral: true,
          numeralPositiveOnly: true,
          prefix: "%",
          noImmediatePrefix: true,
          rawValueTrimPrefix: true,
          tailPrefix: true
        };
        allRules = {
          validate: validateNumber,
          ...rules
        };
        errorMsg = numberErrorMsg;
      } else if (type === "number") {
        allCleaveOptions = {
          numeral: true,
          numeralPositiveOnly: true
        };
        allRules = {
          validate: validateNumber,
          ...rules
        };
        errorMsg = numberErrorMsg;
      }
      formElement = allCleaveOptions ? /*#__PURE__*/_react.default.createElement(Controller, {
        control: control,
        rules: allRules,
        type: typeAttribute,
        name: nameAttribute,
        id: idAttribute,
        defaultValue: defaultValueAttribute,
        iconName: iconName,
        render: ({
          field: {
            ref,
            ...field
          }
        }) => {
          const fieldProps = {
            ...field,
            ...getEventHandlers(field)
          };
          return /*#__PURE__*/_react.default.createElement(_react2.default, Object.assign({
            options: allCleaveOptions,
            placeholder: placeholderAttribute
          }, fieldProps, {
            inputRef: ref,
            onInit: cleave => setCleave(cleave),
            disabled: disabledAttribute
          }));
        }
      }) : /*#__PURE__*/_react.default.createElement("input", Object.assign({
        type: typeAttribute,
        name: nameAttribute,
        id: idAttribute,
        defaultValue: defaultValueAttribute,
        placeholder: placeholderAttribute,
        ref: ref,
        disabled: disabledAttribute
      }, register(nameAttribute, {
        ...allRules,
        ...getEventHandlers()
      })));
    } else if (field === "select") {
      fieldGroupProps = {
        ...fieldGroupProps,
        isSelectFocused,
        showLabel,
        isFieldEmpty: watch && watch(nameAttribute) === "" || !watch(nameAttribute)
      };
      let options = selectOptions;
      if (type === "state") {
        defaultValueAttribute = defaultValue || "State";
        placeholderAttribute = placeholder || "Please select a state.";
        labelTxt = "State";
        options = _utils.stateSelectOptions;
      }
      errorMsg = errorMessage || `Please select a state.`;
      formElement = /*#__PURE__*/_react.default.createElement(Controller, {
        control: control,
        rules: allRules,
        name: nameAttribute,
        id: idAttribute,
        defaultValue: defaultValueAttribute,
        render: ({
          field
        }) => {
          const fieldProps = {
            ...field,
            ...getEventHandlers(field)
          };
          return /*#__PURE__*/_react.default.createElement(_reactSelect.default, Object.assign({
            className: `select`,
            classNamePrefix: "select",
            isSearchable: isSearchable,
            onMenuClose: () => {
              setIsSelectFocused(false);
            },
            onMenuOpen: () => setIsSelectFocused(true),
            options: options.map(({
              value,
              text
            }) => {
              return {
                value,
                label: text
              };
            }),
            components: {
              DropdownIndicator: ({
                innerProps,
                isDisabled
              }) => /*#__PURE__*/_react.default.createElement(_generic.default, Object.assign({
                icon: iconName || "chevron-down",
                color: isDisabled ? _utils.colors["grey-3"].hex : _utils.colors["dusky-grey-6"].hex,
                title: ""
              }, innerProps))
            },
            placeholder: placeholderAttribute,
            classNames: {
              clearIndicator: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName, _selectFieldClassName2, _selectFieldClassName3;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName = selectFieldClassNames.clearIndicator) !== null && _selectFieldClassName !== void 0 && _selectFieldClassName.default ? selectFieldClassNames.clearIndicator.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName2 = selectFieldClassNames.clearIndicator) !== null && _selectFieldClassName2 !== void 0 && _selectFieldClassName2.disabled ? selectFieldClassNames.clearIndicator.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName3 = selectFieldClassNames.clearIndicator) !== null && _selectFieldClassName3 !== void 0 && _selectFieldClassName3.focused ? selectFieldClassNames.clearIndicator.focused : "" : ``}`;
              },
              container: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName4, _selectFieldClassName5, _selectFieldClassName6;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName4 = selectFieldClassNames.container) !== null && _selectFieldClassName4 !== void 0 && _selectFieldClassName4.default ? selectFieldClassNames.container.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName5 = selectFieldClassNames.container) !== null && _selectFieldClassName5 !== void 0 && _selectFieldClassName5.disabled ? selectFieldClassNames.container.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName6 = selectFieldClassNames.container) !== null && _selectFieldClassName6 !== void 0 && _selectFieldClassName6.focused ? selectFieldClassNames.container.focused : "" : ``}`;
              },
              control: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName7, _selectFieldClassName8, _selectFieldClassName9;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName7 = selectFieldClassNames.control) !== null && _selectFieldClassName7 !== void 0 && _selectFieldClassName7.default ? selectFieldClassNames.control.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName8 = selectFieldClassNames.control) !== null && _selectFieldClassName8 !== void 0 && _selectFieldClassName8.disabled ? selectFieldClassNames.control.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName9 = selectFieldClassNames.control) !== null && _selectFieldClassName9 !== void 0 && _selectFieldClassName9.focused ? selectFieldClassNames.control.focused : "" : ``}`;
              },
              dropdownIndicator: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName10, _selectFieldClassName11, _selectFieldClassName12;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName10 = selectFieldClassNames.dropdownIndicator) !== null && _selectFieldClassName10 !== void 0 && _selectFieldClassName10.default ? selectFieldClassNames.dropdownIndicator.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName11 = selectFieldClassNames.dropdownIndicator) !== null && _selectFieldClassName11 !== void 0 && _selectFieldClassName11.disabled ? selectFieldClassNames.dropdownIndicator.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName12 = selectFieldClassNames.dropdownIndicator) !== null && _selectFieldClassName12 !== void 0 && _selectFieldClassName12.focused ? selectFieldClassNames.dropdownIndicator.focused : "" : ``}`;
              },
              group: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName13, _selectFieldClassName14, _selectFieldClassName15;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName13 = selectFieldClassNames.group) !== null && _selectFieldClassName13 !== void 0 && _selectFieldClassName13.default ? selectFieldClassNames.group.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName14 = selectFieldClassNames.group) !== null && _selectFieldClassName14 !== void 0 && _selectFieldClassName14.disabled ? selectFieldClassNames.group.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName15 = selectFieldClassNames.group) !== null && _selectFieldClassName15 !== void 0 && _selectFieldClassName15.focused ? selectFieldClassNames.group.focused : "" : ``}`;
              },
              groupHeading: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName16, _selectFieldClassName17, _selectFieldClassName18;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName16 = selectFieldClassNames.groupHeading) !== null && _selectFieldClassName16 !== void 0 && _selectFieldClassName16.default ? selectFieldClassNames.groupHeading.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName17 = selectFieldClassNames.groupHeading) !== null && _selectFieldClassName17 !== void 0 && _selectFieldClassName17.disabled ? selectFieldClassNames.groupHeading.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName18 = selectFieldClassNames.groupHeading) !== null && _selectFieldClassName18 !== void 0 && _selectFieldClassName18.focused ? selectFieldClassNames.groupHeading.focused : "" : ``}`;
              },
              indicatorsContainer: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName19, _selectFieldClassName20, _selectFieldClassName21;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName19 = selectFieldClassNames.indicatorsContainer) !== null && _selectFieldClassName19 !== void 0 && _selectFieldClassName19.default ? selectFieldClassNames.indicatorsContainer.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName20 = selectFieldClassNames.indicatorsContainer) !== null && _selectFieldClassName20 !== void 0 && _selectFieldClassName20.disabled ? selectFieldClassNames.indicatorsContainer.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName21 = selectFieldClassNames.indicatorsContainer) !== null && _selectFieldClassName21 !== void 0 && _selectFieldClassName21.focused ? selectFieldClassNames.indicatorsContainer.focused : "" : ``}`;
              },
              indicatorSeparator: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName22, _selectFieldClassName23, _selectFieldClassName24;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName22 = selectFieldClassNames.indicatorSeparator) !== null && _selectFieldClassName22 !== void 0 && _selectFieldClassName22.default ? selectFieldClassNames.indicatorSeparator.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName23 = selectFieldClassNames.indicatorSeparator) !== null && _selectFieldClassName23 !== void 0 && _selectFieldClassName23.disabled ? selectFieldClassNames.indicatorSeparator.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName24 = selectFieldClassNames.indicatorSeparator) !== null && _selectFieldClassName24 !== void 0 && _selectFieldClassName24.focused ? selectFieldClassNames.indicatorSeparator.focused : "" : ``}`;
              },
              input: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName25, _selectFieldClassName26, _selectFieldClassName27;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName25 = selectFieldClassNames.input) !== null && _selectFieldClassName25 !== void 0 && _selectFieldClassName25.default ? selectFieldClassNames.input.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName26 = selectFieldClassNames.input) !== null && _selectFieldClassName26 !== void 0 && _selectFieldClassName26.disabled ? selectFieldClassNames.input.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName27 = selectFieldClassNames.input) !== null && _selectFieldClassName27 !== void 0 && _selectFieldClassName27.focused ? selectFieldClassNames.input.focused : "" : ``}`;
              },
              loadingIndicator: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName28, _selectFieldClassName29, _selectFieldClassName30;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName28 = selectFieldClassNames.loadingIndicator) !== null && _selectFieldClassName28 !== void 0 && _selectFieldClassName28.default ? selectFieldClassNames.loadingIndicator.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName29 = selectFieldClassNames.loadingIndicator) !== null && _selectFieldClassName29 !== void 0 && _selectFieldClassName29.disabled ? selectFieldClassNames.loadingIndicator.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName30 = selectFieldClassNames.loadingIndicator) !== null && _selectFieldClassName30 !== void 0 && _selectFieldClassName30.focused ? selectFieldClassNames.loadingIndicator.focused : "" : ``}`;
              },
              loadingMessage: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName31, _selectFieldClassName32, _selectFieldClassName33;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName31 = selectFieldClassNames.loadingMessage) !== null && _selectFieldClassName31 !== void 0 && _selectFieldClassName31.default ? selectFieldClassNames.loadingMessage.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName32 = selectFieldClassNames.loadingMessage) !== null && _selectFieldClassName32 !== void 0 && _selectFieldClassName32.disabled ? selectFieldClassNames.loadingMessage.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName33 = selectFieldClassNames.loadingMessage) !== null && _selectFieldClassName33 !== void 0 && _selectFieldClassName33.focused ? selectFieldClassNames.loadingMessage.focused : "" : ``}`;
              },
              menu: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName34, _selectFieldClassName35, _selectFieldClassName36;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName34 = selectFieldClassNames.menu) !== null && _selectFieldClassName34 !== void 0 && _selectFieldClassName34.default ? selectFieldClassNames.menu.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName35 = selectFieldClassNames.menu) !== null && _selectFieldClassName35 !== void 0 && _selectFieldClassName35.disabled ? selectFieldClassNames.menu.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName36 = selectFieldClassNames.menu) !== null && _selectFieldClassName36 !== void 0 && _selectFieldClassName36.focused ? selectFieldClassNames.menu.focused : "" : ``}`;
              },
              menuList: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName37, _selectFieldClassName38, _selectFieldClassName39;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName37 = selectFieldClassNames.menuList) !== null && _selectFieldClassName37 !== void 0 && _selectFieldClassName37.default ? selectFieldClassNames.menuList.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName38 = selectFieldClassNames.menuList) !== null && _selectFieldClassName38 !== void 0 && _selectFieldClassName38.disabled ? selectFieldClassNames.menuList.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName39 = selectFieldClassNames.menuList) !== null && _selectFieldClassName39 !== void 0 && _selectFieldClassName39.focused ? selectFieldClassNames.menuList.focused : "" : ``}`;
              },
              menuPortal: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName40, _selectFieldClassName41, _selectFieldClassName42;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName40 = selectFieldClassNames.menuPortal) !== null && _selectFieldClassName40 !== void 0 && _selectFieldClassName40.default ? selectFieldClassNames.menuPortal.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName41 = selectFieldClassNames.menuPortal) !== null && _selectFieldClassName41 !== void 0 && _selectFieldClassName41.disabled ? selectFieldClassNames.menuPortal.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName42 = selectFieldClassNames.menuPortal) !== null && _selectFieldClassName42 !== void 0 && _selectFieldClassName42.focused ? selectFieldClassNames.menuPortal.focused : "" : ``}`;
              },
              multiValue: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName43, _selectFieldClassName44, _selectFieldClassName45;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName43 = selectFieldClassNames.multiValue) !== null && _selectFieldClassName43 !== void 0 && _selectFieldClassName43.default ? selectFieldClassNames.multiValue.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName44 = selectFieldClassNames.multiValue) !== null && _selectFieldClassName44 !== void 0 && _selectFieldClassName44.disabled ? selectFieldClassNames.multiValue.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName45 = selectFieldClassNames.multiValue) !== null && _selectFieldClassName45 !== void 0 && _selectFieldClassName45.focused ? selectFieldClassNames.multiValue.focused : "" : ``}`;
              },
              multiValueLabel: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName46, _selectFieldClassName47, _selectFieldClassName48;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName46 = selectFieldClassNames.multiValueLabel) !== null && _selectFieldClassName46 !== void 0 && _selectFieldClassName46.default ? selectFieldClassNames.multiValueLabel.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName47 = selectFieldClassNames.multiValueLabel) !== null && _selectFieldClassName47 !== void 0 && _selectFieldClassName47.disabled ? selectFieldClassNames.multiValueLabel.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName48 = selectFieldClassNames.multiValueLabel) !== null && _selectFieldClassName48 !== void 0 && _selectFieldClassName48.focused ? selectFieldClassNames.multiValueLabel.focused : "" : ``}`;
              },
              multiValueRemove: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName49, _selectFieldClassName50, _selectFieldClassName51;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName49 = selectFieldClassNames.multiValueRemove) !== null && _selectFieldClassName49 !== void 0 && _selectFieldClassName49.default ? selectFieldClassNames.multiValueRemove.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName50 = selectFieldClassNames.multiValueRemove) !== null && _selectFieldClassName50 !== void 0 && _selectFieldClassName50.disabled ? selectFieldClassNames.multiValueRemove.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName51 = selectFieldClassNames.multiValueRemove) !== null && _selectFieldClassName51 !== void 0 && _selectFieldClassName51.focused ? selectFieldClassNames.multiValueRemove.focused : "" : ``}`;
              },
              noOptionsMessage: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName52, _selectFieldClassName53, _selectFieldClassName54;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName52 = selectFieldClassNames.noOptionsMessage) !== null && _selectFieldClassName52 !== void 0 && _selectFieldClassName52.default ? selectFieldClassNames.noOptionsMessage.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName53 = selectFieldClassNames.noOptionsMessage) !== null && _selectFieldClassName53 !== void 0 && _selectFieldClassName53.disabled ? selectFieldClassNames.noOptionsMessage.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName54 = selectFieldClassNames.noOptionsMessage) !== null && _selectFieldClassName54 !== void 0 && _selectFieldClassName54.focused ? selectFieldClassNames.noOptionsMessage.focused : "" : ``}`;
              },
              option: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName55, _selectFieldClassName56, _selectFieldClassName57;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName55 = selectFieldClassNames.option) !== null && _selectFieldClassName55 !== void 0 && _selectFieldClassName55.default ? selectFieldClassNames.option.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName56 = selectFieldClassNames.option) !== null && _selectFieldClassName56 !== void 0 && _selectFieldClassName56.disabled ? selectFieldClassNames.option.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName57 = selectFieldClassNames.option) !== null && _selectFieldClassName57 !== void 0 && _selectFieldClassName57.focused ? selectFieldClassNames.option.focused : "" : ``}`;
              },
              placeholder: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName58, _selectFieldClassName59, _selectFieldClassName60;
                return (0, _twMerge.twMerge)(` leading-[20px] m-0 text-[16px]  ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName58 = selectFieldClassNames.placeholder) !== null && _selectFieldClassName58 !== void 0 && _selectFieldClassName58.default ? selectFieldClassNames.placeholder.default : ""} ${isDisabled ? (0, _twMerge.twMerge)(`text-[var(--grey-3-hex)] ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName59 = selectFieldClassNames.placeholder) !== null && _selectFieldClassName59 !== void 0 && _selectFieldClassName59.disabled ? selectFieldClassNames.placeholder.disabled : ""}`) : `text-[var(--dusky-grey-6-hex)]`} ${isFocused ? (0, _twMerge.twMerge)(`opacity-0 ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName60 = selectFieldClassNames.placeholder) !== null && _selectFieldClassName60 !== void 0 && _selectFieldClassName60.focused ? selectFieldClassNames.placeholder.focused : ""}`) : `text-[var(--dusky-grey-6-hex)] `}`);
              },
              singleValue: ({
                isDisabled,
                isFocused
              }) => {
                var _selectFieldClassName61, _selectFieldClassName62, _selectFieldClassName63;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName61 = selectFieldClassNames.singleValue) !== null && _selectFieldClassName61 !== void 0 && _selectFieldClassName61.default ? selectFieldClassNames.singleValue.default : ""} ${isDisabled ? (0, _twMerge.twMerge)(`text-[var(--grey-3-hex)] ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName62 = selectFieldClassNames.singleValue) !== null && _selectFieldClassName62 !== void 0 && _selectFieldClassName62.disabled ? selectFieldClassNames.singleValue.disabled : ""}`) : `text-[var(--orca-grey-8-hex)]`} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName63 = selectFieldClassNames.singleValue) !== null && _selectFieldClassName63 !== void 0 && _selectFieldClassName63.focused ? selectFieldClassNames.singleValue.focused : "" : ``}`;
              },
              valueContainer: ({
                isFocused,
                isDisabled
              }) => {
                var _selectFieldClassName64, _selectFieldClassName65, _selectFieldClassName66;
                return ` ${selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName64 = selectFieldClassNames.valueContainer) !== null && _selectFieldClassName64 !== void 0 && _selectFieldClassName64.default ? selectFieldClassNames.valueContainer.default : ""}  ${isDisabled ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName65 = selectFieldClassNames.valueContainer) !== null && _selectFieldClassName65 !== void 0 && _selectFieldClassName65.disabled ? selectFieldClassNames.valueContainer.disabled : "" : ``} ${isFocused ? selectFieldClassNames !== null && selectFieldClassNames !== void 0 && (_selectFieldClassName66 = selectFieldClassNames.valueContainer) !== null && _selectFieldClassName66 !== void 0 && _selectFieldClassName66.focused ? selectFieldClassNames.valueContainer.focused : "" : ``}`;
              }
            }
            // styles={{
            //   placeholder: (provided, state) => ({
            //     ...provided,
            //     color: state.isDisabled
            //       ? colors["grey-3"].hex
            //       : colors["dusky-grey-6"].hex,
            //     fontSize: "16px",
            //     lineHeight: "20px",
            //     margin: 0,
            //     opacity: isSelectFocused ? 0 : 1,
            //   }),
            //   singleValue: (provided, state) => ({
            //     ...provided,
            //     color: state.isDisabled
            //       ? colors["grey-3"].hex
            //       : colors["orca-grey-8"].hex,
            //   }),
            // }}
            ,
            defaultValue: defaultValueAttribute,
            isDisabled: disabled
          }, fieldProps));
        }
      });
    } else if (field === "textarea") {
      fieldGroupProps = {
        ...fieldGroupProps,
        showLabel,
        isFieldEmpty: watch && watch(nameAttribute) === "" || !watch(nameAttribute)
      };
      if (type === "message") {
        placeholderAttribute = `Type your message here`;
        allRules = {
          required: true,
          minLength: 2,
          maxLength: characterLimit,
          ...rules
        };
        labelTxt = labelText || placeholderAttribute || "Message";
        errorMsg = characterLimit && watch(name).length > characterLimit ? `You have exceed the maximum characters.` : errorMessage || `Please enter a longer message.`;
      }
      formElement = /*#__PURE__*/_react.default.createElement("textarea", Object.assign({
        name: nameAttribute,
        id: idAttribute,
        cols: cols,
        rows: rows,
        placeholder: placeholderAttribute,
        defaultValue: defaultValueAttribute,
        ref: ref
      }, register(nameAttribute, {
        minLength: 2,
        maxLength: characterLimit,
        ...allRules,
        ...getEventHandlers()
      }), {
        disabled: disabledAttribute
      }));
    } else if (field === "radio") {
      fieldGroupProps = {
        ...fieldGroupProps,
        showLabel
      };
      formElement = /*#__PURE__*/_react.default.createElement(RadioInput, Object.assign({
        name: nameAttribute,
        "aria-label": ariaLabelAttribute,
        type: "radio",
        value: value,
        id: idAttribute,
        ref: ref
      }, register(nameAttribute, {
        ...allRules,
        ...getEventHandlers()
      }), {
        disabled: disabledAttribute
      }));
    } else if (field === "checkbox") {
      fieldGroupProps = {
        ...fieldGroupProps,
        showLabel
      };
      formElement = /*#__PURE__*/_react.default.createElement(CheckboxInput, Object.assign({
        name: nameAttribute,
        "aria-label": ariaLabelAttribute,
        type: "checkbox",
        value: value,
        id: idAttribute,
        ref: ref
      }, register(nameAttribute, {
        ...allRules,
        ...getEventHandlers()
      }), {
        disabled: disabledAttribute
      }));
    }
    return type === "pass" ? /*#__PURE__*/_react.default.createElement(Rosie, Object.assign({
      title: "pass",
      name: "pass",
      autoComplete: "off",
      tabIndex: "-1"
    }, register("pass"))) : /*#__PURE__*/_react.default.createElement(FieldGroup, Object.assign({}, fieldGroupProps, {
      as: field === "input" ? InputGroup : field === "select" ? SelectGroup : field === "textarea" ? TextAreaGroup : field === "radio" ? RadioGroup : field === "checkbox" ? CheckboxGroup : FieldGroup
    }), /*#__PURE__*/_react.default.createElement(RelativePositionContainer, {
      className: "relative-position-container"
    }, iconTooltipText && showIconTooltip && /*#__PURE__*/_react.default.createElement(Tooltip, {
      tooltipPlacement: iconTooltipPlacement,
      iconPlacement: iconPlacement,
      tooltipIconTitle: iconTitle,
      className: `icon-tooltip ${iconTooltipPlacement === "top" ? "icon-tooltip--placement-top" : "icon-tooltip--placement-bottom"}`
    }, iconTooltipText), iconName && selectIcon(errors && errors[nameAttribute], disabled), formElement, field === "radio" || field === "checkbox" ? /*#__PURE__*/_react.default.createElement(RadioLabel, {
      htmlFor: idAttribute
    }, labelTxt) : /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: idAttribute
    }, labelTxt)), (errors && errors[nameAttribute] || characterLimit) && /*#__PURE__*/_react.default.createElement(MessageContainer, {
      className: "message-container"
    }, errors && errors[nameAttribute] && /*#__PURE__*/_react.default.createElement(ErrorMessage, {
      className: "error-message"
    }, errorMsg), characterLimit && /*#__PURE__*/_react.default.createElement("div", {
      className: `character-limit`
    }, watch(name) ? watch(name).length : 0, " / ", characterLimit)));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, outlinedField(type));
}

// Prop Types

OutlinedField.propTypes = {
  /**
   * Type of field
   */
  field: _propTypes.default.oneOf(["input", "select", "textarea", "radio", "checkbox"]),
  /**
   * Form errors
   */
  errors: _propTypes.default.shape(),
  /**
   * Type of field (e.g. phone, name, email)
   */
  type: _propTypes.default.string,
  /**
   * Name attribute
   */
  name: _propTypes.default.string,
  /**
   * Id attribute
   */
  id: _propTypes.default.string,
  /**
   * Placeholder attribute
   */
  placeholder: _propTypes.default.string,
  /**
   * Default value of field
   */
  defaultValue: _propTypes.default.string,
  /**
   * Ref value
   */
  ref: _propTypes.default.any,
  /**
   * Class name of field
   */
  className: _propTypes.default.string,
  /**
   * Text of field label
   */
  labelText: _propTypes.default.string,
  /**
   * Error message
   */
  errorMessage: _propTypes.default.string,
  /**
   * Register function from useForm hook (react-hook-form)
   */
  register: _propTypes.default.func,
  /**
   * Type of input (e.g. text, tel, email)
   */
  inputType: _propTypes.default.string,
  /**
   * Control prop for Controller component from useForm hook (react-hook-form)
   */
  control: _propTypes.default.shape(),
  /**
   * Controller component (handles registration process) from react-hook-form
   */
  Controller: _propTypes.default.func,
  /**
   * Rules prop for Controller component from useForm hook (react-hook-form)
   * e.g. {required: true}
   */
  rules: _propTypes.default.shape(),
  /**
   * Options for select element
   * e.g. <option value="value">Value</option>
   */
  selectOptions: _propTypes.default.array,
  /**
   * Cols (width) attribute for textarea
   */
  cols: _propTypes.default.number,
  /**
   * Rows (# of lines) attribute for textarea
   */
  rows: _propTypes.default.number,
  /**
   * Aria label (accessibility) attribute
   */
  ariaLabel: _propTypes.default.string,
  /**
   * Value of field
   */
  value: _propTypes.default.string,
  /** Name of icon (Generic Icon) */
  iconName: _propTypes.default.string,
  /** Where should icon be placed inside of field? (left or right) */
  iconPlacement: _propTypes.default.oneOf(["left", "right"]),
  /** Functions to be used on icon (e.g. onClick, onMouseEnter) */
  iconFunctions: _propTypes.default.shape(),
  /** Title attribute for icon (shows when hovering over icon) */
  iconTitle: _propTypes.default.string,
  iconTooltipPlacement: _propTypes.default.oneOf(["bottom", "top"]),
  iconTooltipText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Is field disabled? */
  disabled: _propTypes.default.bool,
  /** Max # of characters field can have */
  characterLimit: _propTypes.default.number,
  /**
   * Function that gets current value of field from react-hook-form
   */
  watch: _propTypes.default.func,
  /** (React-Select) */
  innerProps: _propTypes.default.object,
  /** Is input disabled? (React-Select) */
  isDisabled: _propTypes.default.bool,
  /** Should select field be searchable? */
  isSearchable: _propTypes.default.bool,
  /** Type of options to format input (e.g. { phone: true, delimiter: "-"}) */
  cleaveOptions: _propTypes.default.object,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  /** Should the label be displayed or not? */
  showLabel: _propTypes.default.bool,
  /* classes used for select field e.g. 
  placeholder: {
    default: ``,
    disabled: ``
  } */
  selectFieldClassNames: _propTypes.default.object
};
OutlinedField.defaultProps = {
  field: "input",
  iconPlacement: "left",
  iconTooltipPlacement: "top",
  isSearchable: true,
  showLabel: true
};
OutlinedField.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "OutlinedField",
  "props": {
    "field": {
      "defaultValue": {
        "value": "\"input\"",
        "computed": false
      },
      "description": "Type of field",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"input\"",
          "computed": false
        }, {
          "value": "\"select\"",
          "computed": false
        }, {
          "value": "\"textarea\"",
          "computed": false
        }, {
          "value": "\"radio\"",
          "computed": false
        }, {
          "value": "\"checkbox\"",
          "computed": false
        }]
      },
      "required": false
    },
    "iconPlacement": {
      "defaultValue": {
        "value": "\"left\"",
        "computed": false
      },
      "description": "Where should icon be placed inside of field? (left or right)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"left\"",
          "computed": false
        }, {
          "value": "\"right\"",
          "computed": false
        }]
      },
      "required": false
    },
    "iconTooltipPlacement": {
      "defaultValue": {
        "value": "\"top\"",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"bottom\"",
          "computed": false
        }, {
          "value": "\"top\"",
          "computed": false
        }]
      },
      "required": false
    },
    "isSearchable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Should select field be searchable?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showLabel": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Should the label be displayed or not?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "description": "Form errors",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "type": {
      "description": "Type of field (e.g. phone, name, email)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "name": {
      "description": "Name attribute",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "Id attribute",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "description": "Placeholder attribute",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "defaultValue": {
      "description": "Default value of field",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ref": {
      "description": "Ref value",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "className": {
      "description": "Class name of field",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "labelText": {
      "description": "Text of field label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "errorMessage": {
      "description": "Error message",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "register": {
      "description": "Register function from useForm hook (react-hook-form)",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "inputType": {
      "description": "Type of input (e.g. text, tel, email)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "control": {
      "description": "Control prop for Controller component from useForm hook (react-hook-form)",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "Controller": {
      "description": "Controller component (handles registration process) from react-hook-form",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "rules": {
      "description": "Rules prop for Controller component from useForm hook (react-hook-form)\ne.g. {required: true}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "selectOptions": {
      "description": "Options for select element\ne.g. <option value=\"value\">Value</option>",
      "type": {
        "name": "array"
      },
      "required": false
    },
    "cols": {
      "description": "Cols (width) attribute for textarea",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "rows": {
      "description": "Rows (# of lines) attribute for textarea",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "ariaLabel": {
      "description": "Aria label (accessibility) attribute",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "description": "Value of field",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconName": {
      "description": "Name of icon (Generic Icon)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconFunctions": {
      "description": "Functions to be used on icon (e.g. onClick, onMouseEnter)",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "iconTitle": {
      "description": "Title attribute for icon (shows when hovering over icon)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "iconTooltipText": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false
    },
    "disabled": {
      "description": "Is field disabled?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "characterLimit": {
      "description": "Max # of characters field can have",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "watch": {
      "description": "Function that gets current value of field from react-hook-form",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "innerProps": {
      "description": "(React-Select)",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "isDisabled": {
      "description": "Is input disabled? (React-Select)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "cleaveOptions": {
      "description": "Type of options to format input (e.g. { phone: true, delimiter: \"-\"})",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "onBlur": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "selectFieldClassNames": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};